import { useHistory } from 'react-router-dom';
import ModalMessages from '../../../../components/Modal/ModalSimpleButton'
import { StyledTableBody, StyledTableCell, StyledTableCellLink, StyledTableRow, UXDataTableWithoutBody } from '../../../../components/UXDataTable';
import { StyledTableCellMedium, StyledTableCellSmall } from '../constants';
import './styles.css'

const myCols = [
    "MIDAS #",
    "Container",
    // "Method",
    // "Method Description",
    "Facility",
    "Address",
];

const ModalMethodFacilityExternal = ({
    facilitiesExternal,
    setModalOpen,
    setModalClose,
    modalOpen,
    created
}) => {
    const history = useHistory();
    function onCloseModal() {
        if (setModalClose) setModalClose();
        else setModalOpen(false);
    }
    const modalText = created ? `The work request generated ${facilitiesExternal.length} Shipping requests, and are in draft status` : 
        //`This work request will get splitted into another ${facilitiesExternal.length} requests`;
        `This work request will create one draft shipping request for every EXT facility selected.`;
    return (
        <>
            <ModalMessages title={'Warning external facilites'} buttonText={'Ok'} buttonAction={onCloseModal} open={modalOpen} setOpen={setModalOpen}>
                <div className='modal-method-facility-external-body'>
                    <label>{modalText}</label>
                    <UXDataTableWithoutBody
                        tableWidth='100%'
                        cols={created ? [...myCols, 'Work Request', 'Status'] : myCols}
                        tableId="facilitiesExternal"
                        rowLength={facilitiesExternal?.length}
                        noDataFoundMessage={'No facilties found'}
                    >
                        <StyledTableBody>
                            {facilitiesExternal.map((facilityExternal, index) => {
                                return <StyledTableRow
                                    key={index}
                                >
                                    <StyledTableCellMedium className='workrequest-modal-method-facility-external'>
                                        {facilityExternal?.sampleName}
                                    </StyledTableCellMedium>
                                    <StyledTableCellSmall className='workrequest-modal-method-facility-external'>
                                        {facilityExternal?.containerNumber}
                                    </StyledTableCellSmall>
                                    {/* <StyledTableCellSmall>
                                        {facilityExternal?.method}
                                    </StyledTableCellSmall>
                                    <StyledTableCell>
                                        {facilityExternal?.methodDescription}
                                    </StyledTableCell> */}
                                    <StyledTableCellSmall>
                                        {facilityExternal?.facility}
                                    </StyledTableCellSmall>
                                    <StyledTableCell>
                                        {facilityExternal?.address}
                                    </StyledTableCell>
                                    {created && <StyledTableCellLink
                                        scope="row"
                                        onClick={() => {
                                            history.push("/workRequests");
                                            setTimeout(() => {
                                                history.push(`/newWorkRequestRedesign/${facilityExternal?.workRequestId}`) 
                                            }, 1000)
                                        }}
                                        // component={Link}
                                        // to={{ pathname: `/newWorkRequestRedesign/${facilityExternal?.workRequestId}`}}
                                    >
                                        <a href={`/newWorkRequestRedesign/${facilityExternal?.workRequestId}`}>
                                        {facilityExternal?.workRequestId}
                                        </a>
                                    </StyledTableCellLink>}
                                    {created && <StyledTableCellSmall>
                                        {facilityExternal?.statusName}
                                    </StyledTableCellSmall>}
                                </StyledTableRow>
                            })}
                        </StyledTableBody>
                    </UXDataTableWithoutBody>
                </div>
            </ModalMessages>
        </>
    )
}

export default ModalMethodFacilityExternal